import { staticComponentValueConverter } from '../StaticComponentValues';
import { useSelector } from 'react-redux';
function ContinueOrder_2({ item }) {
  const customization = staticComponentValueConverter(item?.customization);

  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const products = useSelector(state => state.themeSlice.products);
  const firstProduct = products && Object.values(products)?.[0];

  return (
    <>
      <div className="w-full h-full relative flex flex-col">
        <div
          className="mt-auto flex flex-row  justify-between items-center  p-[20px] shadow-2xl"
          style={{
            borderTopWidth: 0.5,
            borderTopColor: 'var(--secondaryThemeColor)',
            borderTopStyle: 'solid',
          }}
        >
          <div className="w-[45%]">
            <div
              className="text-left text-[14px]"
              style={{
                color: 'var(--secondaryThemeColor)',
              }}
            >
              Total Amount
            </div>
            <div
              className="text-left text-[14px]"
              style={{
                fontSize: staticValues[12],
                textDecoration: 'line-through',
                color: 'var(--secondaryThemeColor)',
              }}
            >
              ₺{(firstProduct?.data?.variants?.[0]?.prices[0]?.sellPrice * 1.01)?.toFixed(2)}
            </div>
            <div
              className="text-left text-[14px]"
              style={{ fontSize: staticValues[12], fontWeight: 'bold', color: 'var(--secondaryThemeColor)' }}
            >
              ₺{(firstProduct?.data?.variants?.[0]?.prices[0]?.sellPrice * 0.9)?.toFixed(2)}
            </div>
          </div>
          <div
            className="w-[55%] p-[12px] bg-[#7059EF] text-white rounded-[5px] flex-1"
            style={{
              color: customization?.buttonTextColor,
              backgroundColor: customization?.buttonBackgroundColor,
            }}
          >
            Sipariş Ver
          </div>
        </div>
      </div>
    </>
  );
}

export default ContinueOrder_2;
